import request from "@/utils/request";

// 查询设备故障和寿命通知

// 查询邮件发送记录
export const getDeviceAlertRecord = params => {
	return request({
		url: "/deviceAlertRecord",
		method: "GET",
		params,
	});
};

export const getConfigDeviceAlert = params => {
	return request({
		url: "/deviceAlert/config",
		method: "GET",
		params,
	});
};

export const configDeviceAlert = data => {
	return request({
		url: "/deviceAlert/config",
		method: "POST",
		data,
	});
};
